<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">
  <div
    class="flex sm:flex-row flex-0 sm:items-center sm:justify-between p-6 pb-22 sm:pt-12 sm:pb-28 sm:px-10 bg-default dark:bg-transparent"
  >
    <div class="flex-1 min-w-0">
      <div>
        <div class="flex">
          <a
            class="inline-flex items-center -ml-1.5 text-secondary font-medium"
            [routerLink]="'/profile-detail'"
          >
            <mat-icon
              class="icon-size-5 text-secondary"
              [svgIcon]="'heroicons_solid:chevron-left'"
            ></mat-icon>
            <span class="ml-1">Back</span>
          </a>
        </div>
      </div>
      <div class="mt-2">
        <h2
          class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate"
        >
          {{ isEditMode ? "Edit Profile" : "Profile" }}
        </h2>
      </div>
    </div>
    <div class="flex shrink-0 items-center mt-6 sm:mt-0 sm:ml-4">
      <button
        *ngIf="!isEditMode"
        class="px-8"
        mat-raised-button
        color="primary"
        (click)="toggleEditMode()"
      >
        Edit
      </button>
    </div>
  </div>

  <div
    class="flex-auto -mt-16 p-6 sm:p-10 rounded-t-2xl shadow overflow-y-auto bg-card"
    cdkScrollable
  >
    <!-- Form View -->
    <form
      *ngIf="isEditMode"
      class="p-4 bg-card shadow rounded overflow-hidden"
      [formGroup]="adminForm"
      #adminProfileNgForm="ngForm"
      (ngSubmit)="onFormSubmit()"
    >
      <!-- <div class="flex flex-0 flex-col sm:flex-row sm:items-center sm:justify-between">
                <div class="text-2xl md:text-3xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
                    Admin Information
                </div>
            </div>

            <div class="my-5 border-t"></div> -->

      <div class="grid sm:grid-cols-12 gap-6 w-full mt-8">
        <div class="sm:col-span-6">
          <mat-form-field class="w-full">
            <mat-label>Administrator Name</mat-label>
            <input
              matInput
              formControlName="administratorName"
              (input)="onInputAlphabet($event)"
              required
            />
            <mat-error *ngIf="adminForm.get('administratorName').invalid">
              Name is required
            </mat-error>
          </mat-form-field>
        </div>

        <div class="sm:col-span-6">
          <mat-form-field class="w-full">
            <mat-label>Email</mat-label>
            <input
              matInput
              formControlName="email"
              type="email"
              readonly
              required
            />
            <mat-error *ngIf="adminForm.get('email').invalid">
              Valid email is required
            </mat-error>
          </mat-form-field>
        </div>

        <div class="sm:col-span-6">
          <mat-form-field class="w-full">
            <mat-label>Phone</mat-label>
            <input
              matInput
              formControlName="phone"
              (input)="onInputNumeric($event)"
              required
            />
            <mat-error *ngIf="adminForm.get('phone').invalid">
              Phone is required
            </mat-error>
          </mat-form-field>
        </div>

        <div class="sm:col-span-6">
          <mat-form-field class="w-full">
            <mat-label>Role</mat-label>
            <mat-select formControlName="role" [disabled]="isEditMode" required>
              <mat-option *ngFor="let role of roleOptions" [value]="role.key">
                {{ role.value }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="adminForm.get('role').invalid">
              Role is required
            </mat-error>
          </mat-form-field>
        </div>

        <div class="sm:col-span-6">
          <mat-form-field class="w-full">
            <mat-label>City</mat-label>
            <input
              matInput
              formControlName="city"
              (input)="onInputAlphabet($event)"
            />
            <!-- <mat-error *ngIf="adminForm.get('city').invalid">
              City is required
            </mat-error> -->
          </mat-form-field>
        </div>
      </div>

      <div class="text-center mt-8">
        <button
          type="button"
          (click)="toggleEditMode()"
          mat-raised-button
          class="mr-2"
        >
          Cancel
        </button>
        <button
          type="submit"
          [disabled]="adminForm.invalid || pageLoader"
          mat-raised-button
          color="primary"
        >
          <span *ngIf="!pageLoader">Update</span>
          <span *ngIf="pageLoader">Updating...</span>
        </button>
      </div>
    </form>

    <!-- Details View -->
    <div *ngIf="!isEditMode" class="p-6 sm:p-10">
      <!-- <div class="flex flex-0 flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
        <div class="text-2xl md:text-3xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
            Admin Information
        </div>
    </div>

    <div class="my-5 border-t"></div> -->

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
        <div class="p-4 rounded-lg">
          <label class="block text-md font-bold text-gray-900 mb-1"
            >Admin ID</label
          >
          <p class="text-lg text-gray-600">{{ adminData?.Name || "--" }}</p>
        </div>

        <div class="p-4 rounded-lg">
          <label class="block text-md font-bold text-gray-900 mb-1"
            >Administrator Name</label
          >
          <p class="text-lg text-gray-600">
            {{ adminData?.Administrator_Name__c || "--" }}
          </p>
        </div>

        <div class="p-4 rounded-lg">
          <label class="block text-md font-bold text-gray-900 mb-1"
            >Email</label
          >
          <p class="text-lg text-gray-600">{{ adminData?.Email__c || "--" }}</p>
        </div>

        <div class="p-4 rounded-lg">
          <label class="block text-md font-bold text-gray-900 mb-1"
            >Phone</label
          >
          <p class="text-lg text-gray-600">{{ adminData?.Phone__c || "--" }}</p>
        </div>

        <div class="p-4 rounded-lg">
          <label class="block text-md font-bold text-gray-900 mb-1">Role</label>
          <p class="text-lg text-gray-600">{{ adminData?.Role__c || "--" }}</p>
        </div>

        <div class="p-4 rounded-lg">
          <label class="block text-md font-bold text-gray-900 mb-1">City</label>
          <p class="text-lg text-gray-600">
            {{ adminData?.Town_City__c || "--" }}
          </p>
        </div>
      </div>
    </div>

    <!-- <div class="loaderMain" *ngIf="pageLoader === true">
            <div>
                <img src="assets/TrailFusion/Trail-Fusion-logo.jpg" class="LoaderImage">
                <p class="loaderText">{{pageLoaderText}}</p>
            </div>
        </div> -->
  </div>
</div>
